import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaBroadcastTower } from 'react-icons/fa';
import './Medios.css';

const RADIOS = {
  'radio-las-lajas': {
    title: 'Radio Las Lajas 103.9 FM',
    description: 'Escúchala online en rcnipiales.com',
    url: 'https://rcnipiales.com/radiochannel/radio-las-lajas/',
  },
  'radio-rumba': {
    title: 'Rumba 104.7 FM',
    description: 'Escúchala online en rcnipiales.com',
    url: 'https://rcnipiales.com/radiochannel/rumba-stereo-104-7/',
  },
};

const MediosRadio = () => {
  const { slug } = useParams();
  const radio = slug ? RADIOS[slug] : null;

  if (!radio) {
    return (
      <div className="medios-page">
        <Breadcrumbs />
        <div className="container">
          <p>Radio no encontrada.</p>
          <Link to="/medios">← Volver a Medios</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="medios-page medios-radio-page">
      <Breadcrumbs />
      <div className="container">
        <section className="medios-radio-single">
          <h1 className="medios-radio-single-title"><FaBroadcastTower /> {radio.title}</h1>
          <p className="medios-radio-single-desc">{radio.description}</p>
          <div className="medios-radio-single-actions">
            <a
              href={radio.url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary medios-radio-btn"
            >
              <FaBroadcastTower /> Escuchar en la web del proveedor
            </a>
            <Link to="/medios" className="btn btn-secondary">
              ← Volver a Medios
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MediosRadio;
